import {Breadcrumb, Button} from "antd";
import {useState} from "react";
import { HomeOutlined, PlusOutlined, EyeOutlined, EditOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import AddPublication from "./add";
import ActionsMenu from "../../components/actionsMenu";
import DataTable from "../../components/dataTable";
import ShowService from "./show";

const Services = () => {
    const [addModal, setAddModal] = useState(false);
    const [editModal, setEditModal] = useState(false);
    const [refreshTrigger, setRefreshTrigger] = useState(0);

    const [id, setId] = useState(null);
    const [editId, setEditId] = useState(null);
    const [showModal, setShowModal] = useState(false);

    const handleRefresh = () => {
        setRefreshTrigger((prev) => prev + 1);
    };

    const handleAddSuccess = () => {
        setAddModal(false);
        handleRefresh();
    };

    const handleEditSuccess = () => {
        setEditModal(false);
        handleRefresh();
    };

    const columns = [
        {
            key: "title",
            dataIndex: "title",
            title: "Titre",
        },
        {
            key: "created_at",
            dataIndex: "created_at",
            title: "Date de création",
            render: (created_at) =>
                dayjs(created_at).format("DD/MM/YYYY à HH:mm:ss"),
        },
        {
            title: "",
            width: "150px",
            render: (_, record) => (
                <ActionsMenu
                    actions={[
                        {
                            key: "view",
                            label: "Voir les détails",
                            icon: <EyeOutlined />,
                            onClick: () => {
                                setId(record.id);
                                setShowModal(true);
                            },
                        },
                        {
                            key: "edit",
                            label: "Modifier",
                            icon: <EditOutlined />,
                            onClick: () => {
                                setEditId(record.id);
                                setEditModal(true);
                            },
                        },
                    ]}
                />
            ),
        },
    ];

    return (
        <>
            <AddPublication
                open={addModal}
                setOpen={setAddModal}
                onSuccess={handleAddSuccess}
            />

            {/*<HasAccess permissions="update_publications">*/}
            {/*    <AddPublication*/}
            {/*        id={editId}*/}
            {/*        open={editModal}*/}
            {/*        setOpen={setEditModal}*/}
            {/*        onSuccess={handleEditSuccess}*/}
            {/*    />*/}
            {/*</HasAccess>*/}

            <ShowService
                id={id}
                open={showModal}
                setOpen={setShowModal}
            />

            <div className="flex flex-row mt-8">
                <Breadcrumb>
                    <Breadcrumb.Item href="/">
                        <HomeOutlined />
                    </Breadcrumb.Item>
                    <Breadcrumb.Item href="">
                        Services
                    </Breadcrumb.Item>
                </Breadcrumb>

                <div className="ml-auto">
                    <Button
                        icon={<PlusOutlined />}
                        onClick={() => setAddModal(true)}
                        type="primary"
                    >
                        Ajouter un service
                    </Button>
                </div>
            </div>

            <DataTable
                url="/admin/services"
                columns={columns}
                refreshTrigger={refreshTrigger}
                pagination={false}
            />
        </>
    );
};

export default Services;
